import React from "react";

const DevicesRow = ({ index, litTerm }) => (
  <a href={litTerm.showPath}>
    <div className={`row ${index === 0 ? "first" : ""}`}>
      <h2 className="title-4 term tw-m-0 tw-inline">{litTerm.name} </h2>
      <span className="body-2">
        {litTerm.keyExamplesCount} key{" "}
        {litTerm.keyExamplesCount > 1 ? "examples" : "example"}
      </span>
      <div className="md:tw-hidden pull-right arrow">
        <i className="lc-icon lc-icon-sm lc-icon-right" />
      </div>
    </div>
  </a>
);

export default DevicesRow;
